<div *ngIf="loading" class="card-base"></div>
<form *ngIf="!generated" [formGroup]="form" (ngSubmit)="generate()">
  <div *ngIf="!loading" class="edit-actions-cash-desk">
    <mat-spinner *ngIf="loadingAction" matSuffix [diameter]="20"></mat-spinner>
    <button
      *ngIf="!loadingAction && !noClose"
      matTooltip="Cancelar"
      type="button"
      (click)="close()"
      mat-icon-button
      class="card-inline"
    >
      <mat-icon>clear</mat-icon>
    </button>
    <button
      *ngIf="!loadingAction"
      matTooltip="Generar"
      type="submit"
      mat-icon-button
      class="card-inline"
    >
      <mat-icon>done</mat-icon>
    </button>
  </div>
  <div class="card-base-actions">
    <div class="card-content-cash-desk">
      <div class="card-container mat-elevation-z1">
        <div class="card-content">
          <mat-spinner *ngIf="loading"></mat-spinner>
          <app-invoice-cash-desk-edit-control
            *ngIf="!loading && cashDeskUserOpen"
            #invoiceCaskDeskEditControl
            [cashdeskuseropen]="cashDeskUserOpen"
            formControlName="InvoiceCashDesk"
          ></app-invoice-cash-desk-edit-control>
        </div>
      </div>
    </div>
  </div>
</form>

<invoice-cash-desk-view
  [atention]="atention"
  [appointmentId]="medicalappointmentid"
  [invoiceId]="invoiceId"
  (onClose)="close()"
  *ngIf="generated"
></invoice-cash-desk-view>
